var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
    { // 0%
      translateX: 0,
      translateY: 0,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 0
    },
    {
      translateX: 0,
      translateY: -_vm.windowHeight -200,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 500
    }
  ],"triggerAt":_vm.fifthStepTriggerAtPoint + 1100,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: -4000,
        translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      { // 100%
        translateX: _vm.windowWidth,
        translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":_vm.firstStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.firstStep[0],"alt":"animated train coming from the left"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: -_vm.windowWidth -300,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: -100,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 250
      }
    ],"triggerAt":_vm.firstStepTriggerAtPoint + 800,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{style:({background: '#eee', width: (_vm.windowWidth + 200) + 'px', height: _vm.windowHeight + 'px', transform: 'skewX(-10deg)'})})]),_c('animate-x',{staticClass:"absolute w-full",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: _vm.windowWidth,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.secondStepTriggerAtPoint + 1500,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .7,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .7,
          translateY: _vm.windowHeight * .4,
          rotate: 1,
          scale: 1,
          opacity: 1,
          duration: 500
        } ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"rotating circle 1"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .55,
          translateY: _vm.windowHeight * .05,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .55,
          translateY: _vm.windowHeight * .05,
          rotate: 1,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .10 + 'px'}),attrs:{"src":_vm.secondStep[1],"alt":"rotating circle 2"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .52,
          translateY: _vm.windowHeight * .25,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .52,
          translateY: _vm.windowHeight * .25,
          rotate: 1,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[1],"alt":"rotating circle 3"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .26,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .26,
          translateY: _vm.windowHeight * .1,
          rotate: 1,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .17 + 'px'}),attrs:{"src":_vm.secondStep[2],"alt":"rotating circle 4"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .08,
          translateY: _vm.windowHeight * .08,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .08,
          translateY: _vm.windowHeight * .08,
          rotate: 1,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .08 + 'px'}),attrs:{"src":_vm.secondStep[3],"alt":"rotating circle 5"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: (_vm.windowHeight + "px"), width: 'auto'}),attrs:{"src":_vm.secondStep[4],"alt":"statics circles"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * 0.55,
          translateY: _vm.windowHeight * 0.45,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * 0.55,
          translateY: _vm.windowHeight * 0.45,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen absolute"},[_c('h2',{staticStyle:{"color":"#ec6608","font-weight":"600","font-size":"45px"}},[_vm._v("Repairing")]),_c('p',{staticStyle:{"font-size":"24px","margin-bottom":"1rem","font-weight":"300"}},[_vm._v(" Imagine a hammer hitting"),_c('br'),_vm._v(" the head of a nail. Now"),_c('br'),_vm._v(" imagine that impact"),_c('br'),_vm._v(" thousands of times a day. ")]),_c('p',{staticStyle:{"font-size":"24px","margin-bottom":"1rem","font-weight":"300"}},[_vm._v(" That's what railway tracks"),_c('br'),_vm._v(" have to endure - and over"),_c('br'),_vm._v(" time, they can get damaged,"),_c('br'),_vm._v(" and cause delays. ")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: -_vm.windowWidth,
          translateY: _vm.windowHeight * .35,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .04,
          translateY: _vm.windowHeight * .35,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .6 + 'px'}),attrs:{"src":_vm.secondStep[5],"alt":"Big circle coming from the left"}}),_c('div',{staticClass:"sr-only"},[_c('p',[_vm._v("The rail milling train has large wheels with hundreds of cutting tips on them that grind away these defects.")]),_c('p',[_vm._v("They shave small imperfections off the rail head, before a polishing wheel leaves a smooth finish.")]),_c('p',[_vm._v("There's even a spare set of 'teeth' on the train to swap out and keep the milling train working.")])])])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: _vm.windowWidth,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1000,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute z-10",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .65,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .65,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .8 + 'px'}),attrs:{"src":_vm.thirdStep[0],"alt":"worker fade in"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .05,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .05,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"arrow patter fade in"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .1,
          translateY: -_vm.windowHeight,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .1,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .8 + 'px'}),attrs:{"src":_vm.thirdStep[2],"alt":"screen coming from the top"}})]),_c('animate-x',{staticClass:"absolute z-10",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .55,
          translateY: _vm.windowHeight * .18,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .55,
          translateY: _vm.windowHeight * .18,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[3],"alt":"speech bubble"}}),_c('div',{staticClass:"sr-only"},[_c('p',[_vm._v("This is a spare of 'teeth' before they are fixed onto the milling train wheels.")])])])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -_vm.windowHeight,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fourthStepTriggerAtPoint + 1000,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .1,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .1,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .3 + 'px'}),attrs:{"src":_vm.fourthStep[0],"alt":"zig zag pattern fade in"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .1,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .1,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('p',{staticClass:"w-screen absolute",staticStyle:{"font-size":"30px"}},[_vm._v(" This specialist technique and equipment"),_c('br'),_vm._v(" repairs the rails in a fraction of the time it"),_c('br'),_vm._v(" would take to replace them, a saving of ")])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: _vm.windowHeight * .35,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: 0,
          translateY: _vm.windowHeight * .35,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen bg-center bg-auto-100 bg-no-repeat",style:({'background-image': ("url(" + (_vm.fourthStep[1])), 'height': _vm.windowHeight * .5 + 'px' })},[_c('div',{staticClass:"sr-only"},[_vm._v("20% OF THE COST OF NEW TRACK")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .7,
          translateY: _vm.windowHeight * .07,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .7,
          translateY: _vm.windowHeight * .07,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .25 + 'px'}),attrs:{"src":_vm.fourthStep[2],"alt":"butterflies"}})])],1),_c('animate-x',{staticClass:"absolute z-10",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.fifthStep[0]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: -3000,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.fifthStep[1])), width: '6000px'})})]),_c('animate-x',{staticClass:"absolute",staticStyle:{"z-index":"10"},attrs:{"keyframes":[
      { // 0%
        translateX: _vm.windowWidth * .4,
        translateY: _vm.windowHeight * .15,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: _vm.windowWidth * .4,
        translateY: _vm.windowHeight * .15,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .3 + 'px'}),attrs:{"src":_vm.fifthStep[2],"alt":"speech bubble"}}),_c('p',{staticClass:"sr-only"},[_vm._v("It means: less cost, less time to repair, less disruption for passengers!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }